import userActions from '../../actions';

const activation = (state = { status: `unknown` }, action) => {
  switch (action.type) {
    case userActions.ACTIVATE_USER_SUCCESS:
      return {
        ...state,
        status: `success`,
      };
    case userActions.ACTIVATE_USER_FAILURE:
      return {
        status: `error`,
        response: action.error,
      };
    default:
      return state;
  }
};

export default activation;
